<template>
  <form class="vueForm vueFormStep fallbackForm" action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST" @submit="formSubmit($event)">
    <header v-if="showHeaders === 'true'">
      <h5 class="vueForm__header font__color--orange">Thanks for your interest in&nbsp;ShopKeep!</h5>
      <p class="vueForm__subheader font__color--steel">Just tell us the best way to reach you. We'll take it from there.</p>
    </header>
    <div class="vueForm__fields">
      <input type=hidden name="oid" value="00D80000000PNFh">
      <input type=hidden name="Lead_Source_Notes__c" value="Inbound Lead Backup Form">
      <input type=hidden name="retURL" value="https://www.shopkeep.com/thank-you-confirmation">
      <input placeholder="First Name" id="first_name" maxlength="40" name="first_name" size="20" type="text" autofocus />
      <input placeholder="Last Name" id="last_name" maxlength="80" name="last_name" size="20" type="text" required />
      <input placeholder="Business Name" id="company" maxlength="40" name="company" size="20" type="text" required />
      <input placeholder="Phone Number" id="phone" maxlength="40" name="phone" size="20" type="text" required />
      <input placeholder="Business Email" id="email" maxlength="80" name="email" size="20" type="email" pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+[^.]\.[A-Za-z]{2,}$" required />
      <button type="submit" name="submit" value="submit">Get my free quote</button>
    </div>
  </form>
</template>

<script>
  /* globals dataLayer */

  export default {
    props: {
      showHeaders: {
        type: String,
        default: "true"
      },
    },
    methods: {
      formSubmit(event) {
        dataLayer.push({ 'event': 'webForm', 'formType': 'FallBack', 'formAction': 'Submit', 'fieldValue': this.$root.lightboxCta});
        return true;
      },
    },
  };
</script>
